import React from "react";

import { ProtectedByRecaptcha } from "~/screens/Auth/components/ProtectedByRecaptcha.tsx";
import Support from "~/screens/Auth/components/Support";
import { tw } from "~/utils";

interface FooterProps {
  showSupport?: boolean;
  showMightyNetworks?: boolean;
  showProtectedByRecaptcha?: boolean;
}

export const Footer = ({
  showSupport,
  showMightyNetworks,
  showProtectedByRecaptcha,
}: FooterProps) => {
  return (
    <footer
      className={tw(
        `text-footer-text flex w-full flex-col gap-1 px-8 py-4 text-xs ${showSupport ? "items-center border-t border-gray-200 text-center" : "items-end text-right"}`,
      )}
    >
      {showSupport && <Support />}
      {showMightyNetworks && (
        <div className="">
          By logging in, I agree to Mighty Networks{" "}
          <a
            href="https://www.mightynetworks.com/terms-of-use#_gl=1*1iepiiq*_ga*MTkwMTQ5ODQwOC4xNzM5NDY5MjAy*_ga_T49FMYQ9FZ*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My4wLjAuMA..*_ga_NEGJ2SXNP7*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My41Ny4wLjA"
            target="_blank"
            className="underline"
            aria-description="Terms of Use link"
            role="link"
          >
            Terms of Use
            <span className="sr-only"> (opens in a new tab)</span>
          </a>{" "}
          and{" "}
          <a
            href="https://www.mightynetworks.com/privacy-policy#_gl=1*1iepiiq*_ga*MTkwMTQ5ODQwOC4xNzM5NDY5MjAy*_ga_T49FMYQ9FZ*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My4wLjAuMA..*_ga_NEGJ2SXNP7*MTczOTQ2OTIwMS4xLjEuMTczOTQ2OTM4My41Ny4wLjA."
            target="_blank"
            className="underline"
            aria-description="Privacy Policy link"
            role="link"
            rel="noopener noreferrer"
          >
            Privacy Policy
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
          .
        </div>
      )}

      {showProtectedByRecaptcha && <ProtectedByRecaptcha />}

      <p>© {new Date().getFullYear()}, Elektra Health</p>
    </footer>
  );
};
